import { AxiosResponse } from "axios";
import BimsHttpService from "@/services/BimsHttpService";
import { DatabaseTablesActivePeople, DatabasePeopleTerminationDiscrepancy } from "@/services/models/DatabaseStatistics";

class DatabaseStatisticsService {
    /**
     * @description Fetches active people database statistic
     */
    getActivePeopleDatabaseStatistics(): Promise<Array<DatabaseTablesActivePeople>> {
        return BimsHttpService.get("databaseStatistics/activepeople")
            .then((response: AxiosResponse<Array<DatabaseTablesActivePeople>>) => {
                return response.data as any;
            });
    }

    /**
     * @description Fetches famisdb people termination discrepancies database statistic
     */
    getFAMISDBPeopleTerminationDiscrepanciesDatabaseStatistics(): Promise<Array<DatabasePeopleTerminationDiscrepancy>> {
        return BimsHttpService.get("databaseStatistics/famisdb/peopleterminationdiscrepancies")
            .then((response: AxiosResponse<Array<DatabasePeopleTerminationDiscrepancy>>) => {
                return response.data as any;
            });
    }

    /**
     * @description Fetches famisdb title discrepancies database statistic
     */
    getFAMISDBTitleDiscrepanciesDatabaseStatistics(): Promise<any> {
        return BimsHttpService.get("databaseStatistics/famisdb/titlediscrepancies")
            .then((response: AxiosResponse<any>) => {
                return response.data as any;
            });
    }
}

export default new DatabaseStatisticsService();



